import Projects from './Projects'
import { useGetProjectSetupsQuery } from '@/redux/service/project'

const Setup = () => {
  return (
    <div className='h-full'>
      <Projects
        projectquery={useGetProjectSetupsQuery}
        title='Project Setups'
      />
    </div>
  )
}

export default Setup
